// extracted by mini-css-extract-plugin
export default {"maindiv":"Home_maindiv__0t7Fz","homeCardBorder":"Home_homeCardBorder__xI5-e"};